import React, { ReactNode, ReactNodeArray } from 'react'
import { Subtitle1 } from '../StyledText'
import { StyledCustomFieldGroup } from './styled'

interface ICustomFieldGroup {
  label?: string
  error?: string | false
  children: ReactNode | ReactNodeArray
}

export const CustomFieldGroup = ({
  label,
  error,
  children,
}: ICustomFieldGroup) => (
  <StyledCustomFieldGroup isDanger={!!error}>
    {label && <Subtitle1 className="group-label">{label}</Subtitle1>}
    {children}
    {error && (
      <Subtitle1 className="help-text" style={{ marginTop: '8px' }}>
        {error}
      </Subtitle1>
    )}
  </StyledCustomFieldGroup>
)
